module.exports = __webpack_public_path__ + "static/FOTO_2-3df30e0aa11bb7b51528586a1ef71c8c.png";